/**
 * Commerce7 Collection Filter - clear filter handle
 */
import { renderVivinoScore } from "./c7-util";

export default function C7Collection() {
    this.init = () => {
        c7.addAction("c7_collection_products_rendered", (collection) => {
            // Do something after collection rendered.
            loadMoreWines();
            formatPrice();
            handleLoadMore();
        });
    };
    const loadMoreWines = () => {
        const products = jQuery(".c7-product-collection__product-list .c7-product:not(.display)");
        products.map(function (index) {
            if (index < 12) jQuery(this).addClass("display");
        });

        const count = jQuery(".c7-product.display").length;
        const total = jQuery(".c7-product").length;
        if (total <= count) {
            jQuery(".pagination-container button").hide();
        } else {
            jQuery(".pagination-container button").show();
        }
        jQuery(".c7-product-collection .loader").hide();
    }
    const formatPrice = () => {
        jQuery(
            ".c7-product__add-to-cart__price span.c7-sr-only + span,.c7-product__add-to-cart__price .c7-price--discounted"
        ).each(function (i, e) {
            let text = jQuery(e).text();
            jQuery(e).text(
                text.replace("$", "").replace(".00", "").replace("Was", "").replace("Now", "")
            );
            jQuery(e).prepend(`<span class="currency">$</span>`)
        });
        jQuery(
            ".c7-product__add-to-cart__price"
        ).css("display", "flex")
    }
    const handleLoadMore = () => {
        jQuery('.pagination-container button').click(function () {
            loadMoreWines();
        })
    }
}
